import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kn9e9uva6: FaireProductEntity = {
  token: "p_4kn9e9uva6",
  type: "product",
  name: "Beige Beaded Bracelet with Leopard Hide Arkansas",
  brandToken: "b_aogprgmpxh",
  brandName: "GRACE+EMMA by Southern Grace",
  imageUrl:
    "https://cdn.faire.com/fastly/bcb2c430e149d0c89178616262ff14f9d054b1abc042f5e94f6513e4703a537f.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.77,
  description:
    "The Beige Beaded Bracelet with Leopard Hide Arkansas from Southern Grace embodies the spirit of the South, reflecting the strength and sass of Southern women. Designed in-house, this bracelet captures the passion and love inherent in our brand. Its unique leopard hide detail adds a touch of Southern charm to any outfit. Whether you're at a business meeting or a night out, this bracelet will be there to add a touch of grace to your look. Southern Grace, where quality meets comfort and style.",
  tags: [],
  msrpDollars: 6.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:35.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
